import {useComputed} from "@preact/signals-react";
import { adminProductReviewItemClicked, adminProductReviewRawTableData } from "../@signals";

export default function useAdminProductReviewItems() {
	const tableData = useComputed(() => {
		if (adminProductReviewRawTableData.value === null)
			return []
		
		const rowData = adminProductReviewRawTableData.value.filter(item => item.key === adminProductReviewItemClicked.value)[0] || []
		const detailsFiltered = adminProductReviewRawTableData.value.filter(item => item.key === adminProductReviewItemClicked.value)[0]?.details || []

		// El item manda sobre la fila, no al revés: cada oferta trae su vendedor y su precio, y
		// con el orden contrario la fila los pisaba y las tres salían idénticas.
		return detailsFiltered.map(item => ({
			...rowData,
			...item
		}))

	})

	return {
		showTable: !!tableData.value.length,
		tableData: tableData.value
	}
}